import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '@equine-ui-nx/injection-tokens';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentDonationsService {
  private http = inject(HttpClient);
  private apiUrl = inject(API_URL);
  // private apiUrl = 'http://localhost:8080/api';


  getDonationPaypalOrder(reference: string, planCode: string, payorUserId: string, amount?: number, assumePercentage = false): Observable<{id: string, donationId: string}> {
    const CREATE_DONATION_PAYPAL_ORDER = `paymentDonations/createPaypalOrder`;

    return this.http.post<{id: string, donationId: string}>(`${this.apiUrl}/${CREATE_DONATION_PAYPAL_ORDER}`, {
      reference, planCode, payorUserId, amount, assumePercentage
    });
  }


  payDonationWithBraintree(reference: string, frequency: string, planCode: string, payorUserId: string, amount: number,
    assumePercentage: boolean, customerId: string, paymentMethodNonce: string, deviceData: string, paymentMethodType: string
  
  ): Observable<{id: string, donationId: string}> {
    const CREATE_DONATION_PAYPAL_ORDER = `paymentDonations/createPaypalOrder`;

    return this.http.post<{id: string, donationId: string}>(`${this.apiUrl}/${CREATE_DONATION_PAYPAL_ORDER}`, {
      reference, planCode, payorUserId, amount: amount * 100, assumePercentage, frequency, paymentMethodNonce, deviceData, paymentMethodType, customerId
    });
  }

  captureOneTimePaymentDonation(donationId: string, paypalOrderId: string): Observable<{id: string, donationId: string}> {
    const CAPTURE_ONE_TIME_PAYMENT_DONATION = `paymentDonations/captureOneTimePaymentDonation`;

    return this.http.post<{id: string, donationId: string}>(`${this.apiUrl}/${CAPTURE_ONE_TIME_PAYMENT_DONATION}`, {
      donationId, paypalOrderId
    });
  }

  createPaypalSubscription(reference: string, frequency: string, planCode: string, payorUserId: string, amount?: number, assumePercentage = false): Observable<{id: string, quantity: string}> {
    const GET_SUBSCRIPTION_PLAN = `paymentDonations/createPaypalSubscription`;

    return this.http.post<{id: string, quantity: string}>(`${this.apiUrl}/${GET_SUBSCRIPTION_PLAN}`, {
      reference, frequency, planCode, payorUserId, amount, assumePercentage
    });
  }

}
